<div class="notd-doc-uploader">
  <div>
    <h6 i18n="@@TAX-DOC-001">IRS Form
    <fa-icon *ngIf="user?.taxDoc" [icon]="['fas', 'check-circle']"></fa-icon>
    </h6>
    <p>
      <span i18n="@@TAX-DOC-002">
      You can add this later, but it is required at the time of payment.
      For tax purposes, you are required to provide either a
      </span>
      <a href="https://www.irs.gov/forms-pubs/about-form-w9" target="_blank">W-9</a>
      if you are a US person or business.  Provide a
      <a href="https://www.irs.gov/formw8ben" target="_blank">W-8BEN</a>
      if you are outside the US.
      <span i18n="@@TAX-DOC-003">Please download and complete the form that applies to you, and upload below.</span>
    </p>
    <div class="col-12 text-center doc-spin" *ngIf="saving">
      <fa-icon [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
    </div>
    <inline-msg [inlineMsg] = "componentMessage"></inline-msg>
  </div>

  <div class="row uploader-save">
    <uploader-field class = "modal-container" class="col-12 col-sm-12 col-md-9 col-lg-10"
    [postUrl]="taxDocUrl" [maxSize]="2097152" (uploaderEmitter)="uploaderTaxEvent($event)"></uploader-field>

    <div class="col-12 col-sm-12 col-md-3 col-lg-2 text-right">
      <button type="button"
              class="btn notd-primary-btn col-12"
              (click)="saveTaxDoc()"
              [disabled] ="error || saving || !canSave()"
              i18n="@@GLOBAL-SAVE">Save</button>
    </div>
  </div>
  <div class="file-info-message" *ngIf="user?.taxDoc">
    <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
    <span>Your IRS Form file is already uploaded. You can check it by <a (click)="getTaxDoc()">clicking this link</a>.</span>
  </div>

</div>
